import moment from "moment";

export function mapDataRows(data: any[]) {
  return data.map((item) => {
    const mappedItem: any = {};
    Object.keys(item).forEach((key) => {
      switch (key) {
        case "id":
          mappedItem["key"] = item[key];
          break;
        case "createdAt":
        case "updatedAt":
        case "lastUpdate":
          mappedItem[key] = moment(item[key]).format("YYYY-MM-DD HH:mm:ss");
          break;
        default:
          mappedItem[key] = item[key];
      }
    });
    return mappedItem;
  });
}
